"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var baseComponent_1 = require("./base/baseComponent");
var ko = require("knockout");
var $ = require("jquery");
var Clipboard = require("clipboard");
var MobileCopyCurrentUrlButtonComponent = (function (_super) {
    __extends(MobileCopyCurrentUrlButtonComponent, _super);
    function MobileCopyCurrentUrlButtonComponent(params, element, templateNodes) {
        var _this = this;
        _super.call(this, params, element, templateNodes);
        this.title = ko.observable();
        this.url = ko.observable();
        this.title(params.title || 'Скопировать сылку');
        this.url(params.url || window.location.href);
        this.alertText = params.alertText || 'Ссылка скопирована';
        var urlClipboard = new Clipboard($(element).find("#copyUrl")[0]);
        urlClipboard.on("success", function () {
            alert(_this.alertText);
            app.closeModal();
        });
    }
    return MobileCopyCurrentUrlButtonComponent;
}(baseComponent_1.default));
ko.components.register("mobile-copy-current-url-button", {});
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = MobileCopyCurrentUrlButtonComponent;
//# sourceMappingURL=mobileCopyCurrentUrlButton.js.map